import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class ViewAttributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show
        };
    }
    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered>
                    <Modal.Header>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {this.props.productAttributes.isRequiredExpiry !== true ? <label className="mb-3"> Expiry: {this.props.productAttributes.dataExpiry.trim()}</label> : ""}

                        <Container>
                            {this.props.productAttributes.isRequiredExpiry === true ?
                                <Row className="mb-1">
                                    <Col xs={8}>
                                        <label > Expiry: {this.props.productAttributes.dataExpiry.trim()}</label>
                                    </Col>
                                </Row>
                                : ""}
                            {this.props.productAttributes.isRequiredPackingDate === true ?
                                <Row className="mb-1">
                                    <Col xs={8}>
                                        <label>Packing Date: {this.props.productAttributes.dataPacking.trim()} </label>
                                    </Col>
                                </Row>
                                : ""}
                            {this.props.productAttributes.isRequiredGrade1 === true ?
                                <Row className="mb-1">
                                    <Col xs={8}>
                                        <label>{this.props.productAttributes.altNameGrade1.trim()}: {this.props.productAttributes.dataGrade1.trim()}</label>
                                    </Col>
                                </Row>
                                : ""}
                            {this.props.productAttributes.isRequiredGrade2 === true ?
                                <Row className="mb-1">
                                    <Col xs={8}>
                                        <label>{this.props.productAttributes.altNameGrade2.trim()}: {this.props.productAttributes.dataGrade2.trim()}</label>
                                    </Col>
                                </Row>
                                : ""}
                            {this.props.productAttributes.isRequiredGrade3 === true ?
                                <Row className="mb-1">
                                    <Col xs={8}>
                                        <label>{this.props.productAttributes.altNameGrade3.trim()}: {this.props.productAttributes.dataGrade3.trim()}</label>
                                    </Col>
                                </Row>
                                : ""}
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                            <Button variant="secondary" style={{ display: this.props.displayAsConfirmationModal === true ? 'block' : 'none' }}  onClick={this.props.onClickOk}>
                                Ok
                            </Button>
                            <Button variant="secondary" style={{ display: this.props.displayAsConfirmationModal === true ? 'block' : 'none' }} onClick={this.props.onClickClose}>
                                Cancel
                            </Button>
                            <Button variant="secondary" style={{ display: this.props.displayAsConfirmationModal === false ? 'block' : 'none' }}  onClick={this.props.onClickClose}>
                                Close
                            </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ViewAttributes;